/**
 * Java 监控告警 HTTP 列表：解析记录与缩略图 URL（与 YsDeviceDrawerBody / NursingAlertsForm 同源字段）
 */

export function pickMonitoringAlarmList (res) {
  const d = res?.data
  if (d == null) return []
  if (Array.isArray(d)) return d
  if (Array.isArray(d.data)) return d.data
  if (Array.isArray(d.list)) return d.list
  if (Array.isArray(d.records)) return d.records
  return []
}

function firstUrlInArray (arr) {
  if (!Array.isArray(arr) || arr.length === 0) return ''
  const u = arr.find((x) => typeof x === 'string' && x.trim() !== '')
  return u ? u.trim() : ''
}

export function getMessageMapFirstThumbnailUrl (record) {
  const m = record?.messageMap
  if (!m || typeof m !== 'object') return ''
  return firstUrlInArray(m.thumbnailUrls)
}

export function getMessageMapFirstFullImageUrl (record) {
  const m = record?.messageMap
  if (!m || typeof m !== 'object') return ''
  const fromFull = firstUrlInArray(m.imageUrls)
  if (fromFull) return fromFull
  return firstUrlInArray(m.thumbnailUrls)
}

export function monitoringRecordTimeMs (record) {
  if (!record || typeof record !== 'object') return 0
  const t0 = Number(record.messageTime)
  if (t0 > 0) return t0 < 1e12 ? t0 * 1000 : t0
  const createdAt = record.createdAt
  if (createdAt != null && createdAt !== '') {
    if (typeof createdAt === 'number' && !Number.isNaN(createdAt)) {
      return createdAt < 1e12 ? createdAt * 1000 : createdAt
    }
    const p = Date.parse(String(createdAt))
    if (!Number.isNaN(p)) return p
  }
  return 0
}

/** 时间最新的一条里有图的 URL（优先缩略图，否则大图） */
export function pickLatestPreviewUrlFromList (list) {
  if (!Array.isArray(list) || list.length === 0) return ''
  const ranked = [...list].sort((a, b) => monitoringRecordTimeMs(b) - monitoringRecordTimeMs(a))
  for (const r of ranked) {
    const u = getMessageMapFirstThumbnailUrl(r) || getMessageMapFirstFullImageUrl(r)
    if (u) return u
  }
  return ''
}
